import { Overline } from "./Reveal";

const OFFICES = [
  { city: "London, UK", address: "4 Winsley Street, London W1W 8HF", phone: "+44-738-030-7979" },
  { city: "Chicago, USA", address: "245 W Roosevelt Rd, West Chicago, IL 60185", phone: "+1-877-735-0397" },
  { city: "Calgary, Canada", address: "246 Stewart Green St, Calgary, T3H 3C8", phone: "+1-872-318-4555" },
  { city: "Dubai, UAE", address: "Level 3, Convention Tower, World Trade Center", phone: "+971-501-599-266" },
  { city: "Delhi NCR, India", address: "C-64, Upper Ground Floor, Sector-2, Noida", phone: "+91-120-450-6748" },
];

const ENTITIES = [
  { name: "Dignifyd Tech", url: "https://www.dignifyd.tech" },
  { name: "Talent Connect", url: "https://dignifydtalentconnect.com" },
  { name: "Dignifyd Digital", url: "https://www.dignifyd.digital" },
  { name: "Dignifyd Group", url: "https://dignifyd.io" },
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-white/10 bg-surface/60">
      <div className="mx-auto max-w-7xl px-6 py-16 lg:px-8">
        <div className="flex flex-col gap-6 border-b border-white/10 pb-12 lg:flex-row lg:items-end lg:justify-between">
          <div>
            <img
              src="/logo.png"
              alt="Dignifyd Group"
              data-testid="footer-logo"
              className="h-9 w-auto"
            />
            <p className="mt-3 max-w-sm text-sm leading-relaxed text-gray-400">
              One relationship. Five specialised capabilities. Building inclusive
              futures through talent, technology and trust.
            </p>
          </div>
          <div className="flex flex-wrap gap-x-8 gap-y-3">
            {ENTITIES.map((e) => (
              <a
                key={e.name}
                data-testid={`footer-entity-${e.name.toLowerCase().replace(/\s+/g, "-")}`}
                href={e.url}
                target="_blank"
                rel="noopener noreferrer"
                className="font-mono text-xs uppercase tracking-[0.2em] text-gray-400 transition-colors duration-300 hover:text-gold"
              >
                {e.name}
              </a>
            ))}
          </div>
        </div>

        <div className="mt-12">
          <Overline>Offices</Overline>
          <div className="mt-6 grid gap-8 sm:grid-cols-2 lg:grid-cols-5">
            {OFFICES.map((o) => (
              <div key={o.city} data-testid={`footer-office-${o.city.split(",")[0].toLowerCase().replace(/\s+/g, "-")}`}>
                <p className="font-heading text-sm font-medium text-white">{o.city}</p>
                <p className="mt-2 text-xs leading-relaxed text-gray-500">{o.address}</p>
                <a
                  href={`tel:${o.phone.replace(/[^+\d]/g, "")}`}
                  className="mt-2 block font-mono text-[11px] text-gray-400 transition-colors duration-300 hover:text-gold"
                >
                  {o.phone}
                </a>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-16 flex flex-col gap-3 border-t border-white/10 pt-8 sm:flex-row sm:items-center sm:justify-between">
          <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-gray-600">
            © 2026 Dignifyd Group. All rights reserved.
          </p>
          <a
            data-testid="footer-email-link"
            href="mailto:hello@dignifyd.io"
            className="font-mono text-[11px] uppercase tracking-[0.2em] text-gray-400 transition-colors duration-300 hover:text-gold"
          >
            hello@dignifyd.io
          </a>
        </div>
      </div>
    </footer>
  );
}
